
import React, { useContext } from 'react';
import CustomizeButton from './CustomizeButton';
import { TabStateContext } from '../providers/TabProvider';
import { HistoryStateContext } from '../providers/HistoryProvider';

export default function TabContents({ activeTab, ...other }) {
  const state = useContext(TabStateContext);
  const historyState = useContext(HistoryStateContext);
  const components = React.Children.toArray(other.children);
  const defaultComponent = components[components.length - 1];
  const { current } = historyState[state.activeTab];
  const childrenWithExtraProp = components.filter((child, index) => {
    const idEquals = state.activeTab === child.props.tabId
                     && current && current.url === child.props.url;
    return idEquals;
  });

  if (!childrenWithExtraProp.length) {
    childrenWithExtraProp.push(defaultComponent);
  }

  const content = React.cloneElement(childrenWithExtraProp[0], current);

  return (
    <div className="chrome-tab-contents" {...other}>
      {content}
      <CustomizeButton />
    </div>
  );
}
